import { NavLink, useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import { adminAPI } from '../../utils/api';

const ADMIN_NAV = [
  { section: 'Overview', items: [{ path: '/admin/dashboard', icon: '⬛', label: 'Dashboard' }] },
  { section: 'Students', items: [
    { path: '/admin/students', icon: '👤', label: 'All Students' },
    { path: '/admin/approvals', icon: '✅', label: 'Approvals', badgeKey: 'pending' },
    { path: '/admin/schools', icon: '🏫', label: 'Schools', badgeKey: 'pendingSchools' },
  ]},
  { section: 'Content', items: [
    { path: '/admin/content', icon: '📚', label: 'Content Library' },
    { path: '/admin/content/review', icon: '🔍', label: 'Review Queue', badgeKey: 'reviewQueue' },
    { path: '/admin/reports', icon: '⚠️', label: 'Error Reports' },
  ]},
  { section: 'Platform', items: [
    { path: '/admin/analytics', icon: '📊', label: 'Analytics' },
    { path: '/admin/comparison', icon: '🔬', label: 'Comparison' },
    { path: '/admin/weekly-reports', icon: '📋', label: 'Weekly Reports' },
    { path: '/admin/branding', icon: '🎨', label: 'Branding & Theme' },
    { path: '/admin/banners', icon: '🖼️', label: 'Banner Slots' },
    { path: '/admin/support', icon: '💬', label: 'Support Tickets', badgeKey: 'tickets' },
    { path: '/admin/announcements', icon: '📢', label: 'Announcements' },
  ]},
  { section: 'Settings', items: [
    { path: '/admin/settings', icon: '⚙️', label: 'Platform Settings' },
    { path: '/admin/admins', icon: '👤', label: 'Admin Users' },
  ]},
];

const AdminSidebar = ({ badges = {}, adminInfo = {} }) => {
  const navigate = useNavigate();
  const { success } = useToast();

  const handleLogout = async () => {
    try {
      await fetch('/api/admin/auth/logout', { method: 'POST', credentials: 'include' });
    } catch {}
    success('Logged out');
    navigate('/admin');
  };

  return (
    <aside style={{ width: '220px', minWidth: '220px', background: '#1A1A2E', display: 'flex', flexDirection: 'column', minHeight: '100vh', paddingBottom: '20px' }}>
      {/* Logo */}
      <div style={{ padding: '18px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: '9px' }}>
        <div style={{ width: '34px', height: '34px', borderRadius: '8px', background: '#FF6B00', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Baloo 2', cursive", fontSize: '15px', fontWeight: 800, color: 'white', flexShrink: 0 }}>G</div>
        <div>
          <div style={{ fontFamily: "'Baloo 2', cursive", fontSize: '12px', fontWeight: 800, color: '#FF6B00', lineHeight: 1.1 }}>MyPersonalGuruji</div>
          <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.3)' }}>Admin Panel</div>
        </div>
      </div>

      {/* Admin info */}
      <div style={{ margin: '10px 16px', background: 'rgba(255,107,0,0.15)', border: '1px solid rgba(255,107,0,0.3)', borderRadius: '8px', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '7px' }}>
        <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#FF6B00', flexShrink: 0 }}></div>
        <div>
          <div style={{ fontSize: '11px', fontWeight: 800, color: '#FFB366' }}>{adminInfo.name || 'Admin'}</div>
          <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)' }}>{adminInfo.role?.replace('_', ' ') || 'Super Admin'}</div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ padding: '8px 10px', flex: 1, display: 'flex', flexDirection: 'column', gap: '1px', overflowY: 'auto' }}>
        {ADMIN_NAV.map(section => (
          <div key={section.section}>
            <div style={{ fontSize: '9px', fontWeight: 800, color: 'rgba(255,255,255,0.25)', letterSpacing: '0.8px', padding: '10px 10px 4px', textTransform: 'uppercase' }}>{section.section}</div>
            {section.items.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                style={({ isActive }) => ({
                  display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 10px', borderRadius: '8px',
                  color: isActive ? 'white' : 'rgba(255,255,255,0.5)',
                  background: isActive ? '#FF6B00' : 'transparent',
                  fontSize: '12px', fontWeight: 600, textDecoration: 'none', marginBottom: '1px'
                })}
              >
                <span style={{ fontSize: '13px', width: '15px', textAlign: 'center' }}>{item.icon}</span>
                {item.label}
                {item.badgeKey && badges[item.badgeKey] > 0 && (
                  <span style={{ marginLeft: 'auto', background: '#DC2626', color: 'white', fontSize: '9px', fontWeight: 800, borderRadius: '10px', padding: '1px 5px' }}>
                    {badges[item.badgeKey]}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
        <button
          onClick={handleLogout}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 10px', borderRadius: '8px', color: 'rgba(255,255,255,0.4)', background: 'transparent', border: 'none', fontSize: '12px', fontWeight: 600, cursor: 'pointer', marginTop: '8px', width: '100%' }}
        >
          <span style={{ fontSize: '13px', width: '15px', textAlign: 'center' }}>🚪</span>
          Logout
        </button>
      </nav>
    </aside>
  );
};

export default AdminSidebar;
